import React, { useState } from "react";
import styles from "./AddTelegramModal.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import ProgressBar from "../../../ProgressBar/ProgressBar";
import CustomButton from "../../../CustomButton/CustomButton";
import { useStepContent } from "./consts";
import { useTranslation } from "react-i18next";
import CustomInput from "../../../CustomInput/CustomInput";
import { useForm } from "react-hook-form";
import { createChannel } from "../../../../api/telegramApi";

const AddTelegramModal = ({ setOpenModal }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const stepContent = useStepContent();

  const {
    register,
    setValue,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      channel_token: "",
      channel_name: "",
    },
    mode: "onChange",
  });

  const handlePreviousStep = () => {
    if (step === 1) {
      return;
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const handleNextStep = async () => {
    if (step < 4) {
      setStep((prev) => prev + 1);
    } else if (step === 4) {
      console.log("START CREATING");

      const data = {
        channel_token: getValues("channel_token"),
        channel_name: getValues("channel_name"),
      };

      try {
        const response = await createChannel({ data });
        console.log(response);
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{t("addTelegramModal.title")}</h2>
          <ExitIcon onClick={() => setOpenModal(null)} />
        </div>
        <ProgressBar step={step} maxStep={4} />

        {step < 4 &&
          stepContent[step - 1].map((item, idx) => (
            <div className={styles.stepContainer} key={idx}>
              <div className={styles.containerContent}>{item.text}</div>
              <div>
                <img src={item.image} alt="" />
              </div>
            </div>
          ))}

        {step === 4 && (
          <div className={styles.modalInputContainer}>
            <CustomInput
              label={t("form.botTokenLabel")}
              placeholder={t("form.botTokenPlaceholder")}
              onChange={(e) => setValue("channel_token", e.target.value)}
              {...register("channel_token", {
                required: t("form.botTokenRequired"),
              })}
              error={errors.botToken ? errors.botToken.message : null}
            />

            <CustomInput
              label={t("form.botNameLabel")}
              placeholder={t("form.botNamePlaceholder")}
              onChange={(e) => setValue("channel_name", e.target.value)}
              {...register("channel_name", {
                required: t("form.botNameRequired"),
              })}
              error={errors.botName ? errors.botName.message : null}
            />
          </div>
        )}

        {step <= 4 && (
          <div className={styles.modalFooter}>
            <CustomButton onClick={handlePreviousStep}>
              {t("addTelegramModal.backButton")}
            </CustomButton>
            <CustomButton blue onClick={handleNextStep}>
              {t("addTelegramModal.nextButton")} {">"}
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddTelegramModal;
